import { Box, Fade, Grid, Grow } from "@mui/material";
import styles from './index.module.css'
import PhoneRoundedIcon from '@mui/icons-material/PhoneRounded';
import MailRoundedIcon from '@mui/icons-material/MailRounded';
import LocationOnRoundedIcon from '@mui/icons-material/LocationOnRounded';
import Form from "./Form";
import { useMediaQuery } from 'react-responsive'
import { useEffect, useRef, useState } from "react";
import ThankYou from "./Form/ThankYou";
import { isMobileQuery } from "../../../utils/helpers";


const Contact = () => {

	const target = useRef(null)
	const formRef = useRef(null)

	const isMobile = useMediaQuery(isMobileQuery)

	const [paddingHeight, setPaddingHeight] = useState(null)
	const [applyTitleAnim, toggleApplyTitleAnim] = useState(false)
	const [applyFormAnim, toggleApplyFormAnim] = useState(false)
	const [isFormSubmitted, setIsFormSubmitted] = useState(false)

	useEffect(() => {
		setTimeout(() => {
			toggleApplyTitleAnim(true)
		}, 200);
		setTimeout(() => {
			toggleApplyFormAnim(true)
		}, 250);
	}, [])

	useEffect(() => {
		const ele = formRef.current
		console.log('hex: ', ele.clientHeight)

		ele.clientHeight && setPaddingHeight(ele.clientHeight)
	}, [])

	const handleAnotherLinkClick = () => {
		setIsFormSubmitted(false)
	}


	return (
		<Box className={`font-[poppins-regular] ${styles['main']}`}
			style={{
				paddingBottom: paddingHeight ? `calc(100vw - calc(0.2 * ${paddingHeight} ))` : 'auto'
			}}
		>
			<Box
				className={
					`w-[100%] object-cover object-center relative isolate` +
					` sm:sticky sm:top-0 sm:before:appearance-none`
				}
				ref={target}>
			</Box>
			<Box className={
				`${styles['main-content']} flex justify-center align-baseline flex-col `
			}>
				<Box className='absolute top-0 -left-[20%] w-[120%] h-[60vh] xs:max-md:h-1/2 overflow-hidden'>
					<Box className={`w-full h-full scale-x-[14] scale-y-[3]`}>
						<lottie-player src="https://lottie.host/7436510d-2f47-4b3e-a6ba-c6708d186355/ECuTVIrln5.json"
							style={{
								height: isMobile ? '100vw' : '100%',
							}}
							className={`w-full h-full xs:max-md:h-1/2`}
							background="transparent" direction="1" speed="1" loop autoplay
						>
						</lottie-player>
					</Box>
				</Box>

				<Box className={`mx-auto z-10`}>
					<Fade in={applyTitleAnim}>
						<Box className={
							`xs:max-sm: mb-[4vh] ` +
							`bg-gradient-to-r from-[#ffffff00] from-1% via-[#ffffff8c] via-[percentage:10%_90%] to-[#ffffff00] to-100% ` +
							`pb-[3vh] mb-[3vh] xs:pb-[1vh] xs:mb-[1vh]` +
							`bg-gradient-to-r from-[#ffffff00] from-1% via-[#ffffffa6] via-[percentage:10%_90%] to-[#ffffff00] to-100% `

						}>
							<Box className={
								`${styles['heading']} text-[color:#132867] font-bold text-center`
							}>
								Get in touch
							</Box>
							<Box className={
								`${styles['sub-heading']} text-[color:#19317b] leading-snug tracking-tighter text-center`
							}>
								We'll create high-quality linkable content and build at least 40 high-authority links to each
								asset, paving the way for you to grow your rankings, improve brand.
							</Box>
						</Box>
					</Fade>

					<Grow in={applyFormAnim}>
						<Box className={
							`bg-transparent ` +
							` bg-[color:rgb(225,232,239)] rounded-[length:var(--border-radius)] ` +
							`sm:bg-gradient-to-t from-[color:rgba(225,232,239,1)] from-1% to-[color:rgba(255,255,255,1)] to-100% `
						}>
							<Grid container className={`!flex-col-reverse sm:!flex-row gap-[${Math.ceil(paddingHeight * 0.3)}px] xs:max-sm:items-center`}>
								<Grid item className={`p-[10px] ${styles['reach-out-container']}`} sm={5} ref={formRef}>
									<section className={
										`${styles['contact-section']} ` +
										`text-left relative bg-[color:var(--bg-blue)] px-[19px] py-[30px] pt-4 pl-[length:calc(3 * var(--form-side-spacing))] h-full isolate ` +
										`ms:max-lg:pr-[15px] `
									}>
										<Box className={`${styles['c-title']} mb-[0.1em] sm:max-lg:leading-[1.3] sm:max-lg:mb-[10px]`}>
											Reach out to us
										</Box>
										<Box className={`${styles['c-sub-title']} mb-[2rem]`}>
											We'll take care of your concerns with utmost priority.
										</Box>
										<Box className={`mb-[20px] ${styles['c-row']}`}>
											<Grid container spacing={isMobile ? 1 : 3} alignItems={'center'}>
												<Grid item lg={1} md={1} sm={1}>
													<PhoneRoundedIcon
														fontSize={'small'}
													/>
												</Grid>
												<Grid item lg={11} md={10} sm={10} className={`${styles['content']}`}>
													<a href="tel:+91 7977954690">
														+91 7977954690
													</a>
												</Grid>
											</Grid>
										</Box>
										<Box className={`mb-[20px] ${styles['c-row']}`}>
											<Grid container spacing={isMobile ? 1 : 3} alignItems={'center'}>
												<Grid item lg={1} md={1} sm={1}>
													<MailRoundedIcon
														fontSize={'small'}
													/>
												</Grid>
												<Grid item lg={11} md={10} sm={10} className={`${styles['content']} leading-[30px]`}>
													<Box>
														<a href="mailto:info@flintinfotrch.com">
															info@flintinfotrch.com
														</a>
													</Box>
													<Box>
														<a href="mailto:sales@flintinfotrch.com">
															sales@flintinfotrch.com
														</a>
													</Box>
												</Grid>
											</Grid>
										</Box>
										<Box className={`mb-[2rem] ${styles['c-row']}`}>
											<Grid container spacing={isMobile ? 1 : 3} alignItems={'center'}>
												<Grid item lg={1} md={1} sm={1}>
													<LocationOnRoundedIcon
														fontSize={'small'}
													/>
												</Grid>
												<Grid item lg={11} md={10} sm={10} xs={10} className={`${styles['content']}`}>
													<ul className="text-sm mt-5 text-gray-400">
														<li>Office No:S-133, 2nd Floor,</li>
														<li>Haware Fantasia Business Park,</li>
														<li>Vashi, Navi Mumbai-400703, India</li>
													</ul>
												</Grid>
											</Grid>

										</Box>
									</section>
								</Grid>
								<Grid item className={
									`p-[10px] sm:max-sm:mx-auto sm:max-sm:relative sm:max-sm:z-[2] ` +
									`bg-gradient-to-t from-[color:rgba(225,232,239,1)] from-1% to-[color:rgba(255,255,255,1)] to-100% sm:bg-none ` +
									`rounded-2xl sm:rounded-none ` +
									`${styles['right']} ${isFormSubmitted ? styles['submitted'] : ''}`
								} sm={7}>
									<section className={`${styles['form-section']} ${isFormSubmitted ? styles['submitted'] : ''}`}>
										{
											isFormSubmitted ? <>
												<ThankYou
													handleAnotherLinkClick={handleAnotherLinkClick}
												/>
											</> : <>
												<Form
													onSubmitCallback={() => {
														setIsFormSubmitted(true)
													}}
												/>
											</>
										}
									</section>
								</Grid>
							</Grid>
						</Box>
					</Grow>

				</Box>
			</Box>
		</Box>
	);
}

export default Contact;